/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _scripts_components_Bundle_Bundle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./scripts/components/Bundle/Bundle */ "./resources/scripts/components/Bundle/Bundle.ts");
/* harmony import */ var _scripts_components_ShowMoreVariants_ShowMoreVariants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scripts/components/ShowMoreVariants/ShowMoreVariants */ "./resources/scripts/components/ShowMoreVariants/ShowMoreVariants.ts");
/* harmony import */ var _scripts_components_AtcDropdown_AtcDropdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scripts/components/AtcDropdown/AtcDropdown */ "./resources/scripts/components/AtcDropdown/AtcDropdown.ts");
/* harmony import */ var _scripts_components_CustomDropdown_CustomDropdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scripts/components/CustomDropdown/CustomDropdown */ "./resources/scripts/components/CustomDropdown/CustomDropdown.ts");
/* Bundle */

/* ShowMoreVariants */

/* AtcDropdown */

/* CustomDropdown */

customElements.define("bundle-component", _scripts_components_Bundle_Bundle__WEBPACK_IMPORTED_MODULE_0__["default"]);
customElements.define("show-more-variants", _scripts_components_ShowMoreVariants_ShowMoreVariants__WEBPACK_IMPORTED_MODULE_1__["default"]);
customElements.define("atc-dropdown", _scripts_components_AtcDropdown_AtcDropdown__WEBPACK_IMPORTED_MODULE_2__["default"]);
customElements.define("custom-dropdown", _scripts_components_CustomDropdown_CustomDropdown__WEBPACK_IMPORTED_MODULE_3__["default"]);

/***/ }),

/***/ "./resources/scripts/components/AtcDropdown/AtcDropdown.ts":
/*!*****************************************************************!*\
  !*** ./resources/scripts/components/AtcDropdown/AtcDropdown.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ AtcDropdown)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AtcDropdown = /*#__PURE__*/function (_HTMLElement) {
  function AtcDropdown() {
    var _this;
    _classCallCheck(this, AtcDropdown);
    _this = _callSuper(this, AtcDropdown);
    _defineProperty(_this, "titleEl", void 0);
    _defineProperty(_this, "variantEl", void 0);
    _defineProperty(_this, "lineEl", void 0);
    _defineProperty(_this, "totalEl", void 0);
    _defineProperty(_this, "imageEl", void 0);
    _defineProperty(_this, "closeBtn", void 0);
    _defineProperty(_this, "inner", void 0);
    _defineProperty(_this, "hideTimer", null);
    _defineProperty(_this, "mainButtonIntentTs", null);
    _defineProperty(_this, "quickAddIntentTs", null);
    _defineProperty(_this, "preventDrawerHandler", void 0);
    _this.showDropdown = _this.showDropdown.bind(_this);
    _this.hide = _this.hide.bind(_this);
    _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
    _this.handleGlobalClick = _this.handleGlobalClick.bind(_this);
    _this.titleEl = null;
    _this.variantEl = null;
    _this.lineEl = null;
    _this.totalEl = null;
    _this.imageEl = null;
    _this.closeBtn = null;
    _this.inner = null;
    _this.preventDrawerHandler = function (evt) {
      // Always prevent cart drawer opening; we want our dropdown instead
      evt.stopImmediatePropagation();
    };
    return _this;
  }
  _inherits(AtcDropdown, _HTMLElement);
  return _createClass(AtcDropdown, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      // Ensure theme won't try to open the cart drawer after ATC
      try {
        // @ts-ignore
        if (window.theme && theme.settings) theme.settings.afterAtc = "nothing";
      } catch (e) {}
      this.titleEl = this.querySelector(".atc-dropdown__product-title");
      this.variantEl = this.querySelector(".atc-dropdown__variant");
      this.lineEl = this.querySelector(".atc-dropdown__line");
      this.totalEl = this.querySelector(".atc-summary__total");
      this.imageEl = this.querySelector(".atc-dropdown__image img");
      this.closeBtn = this.querySelector(".atc-dropdown__close");
      this.inner = this.querySelector(".atc-dropdown__inner");
      if (this.closeBtn) this.closeBtn.addEventListener("click", this.hide);
      document.addEventListener("click", this.handleOutsideClick);
      // Track explicit intent coming from the main product Add to Cart button
      document.addEventListener("click", this.handleGlobalClick, true);
      // Prevent any attempts to open the cart drawer
      document.addEventListener("dispatch:cart-drawer:open", this.preventDrawerHandler, true);
      // Open the cart drawer when clicking "Se kurv" inside the dropdown
      var openCartLink = this.querySelector(".js-open-cart-drawer");
      if (openCartLink) {
        openCartLink.addEventListener("click", function (evt) {
          evt.preventDefault();
          // Ensure dropdown auto-hide timer won't interfere
          if (_this2.hideTimer) {
            window.clearTimeout(_this2.hideTimer);
            _this2.hideTimer = null;
          }
          // Close the dropdown first
          _this2.hide();
          // Open cart drawer only after dropdown is fully hidden (matches 350ms in hide())
          var openDrawer = function openDrawer() {
            try {
              var cartDrawer = document.querySelector("cart-drawer");
              if (cartDrawer && typeof cartDrawer.open === "function") {
                cartDrawer.open(openCartLink);
              } else {
                // Fallback if direct call not available
                document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open", {
                  detail: {
                    opener: openCartLink
                  }
                }));
              }
            } catch (e) {
              // noop
            }
          };
          if (_this2.hidden) {
            openDrawer();
          } else {
            window.setTimeout(openDrawer, 380);
          }
        });
      }
      document.addEventListener("on:cart:add", function (evt) {
        var _evt$detail;
        // Ignore Quick Add interactions entirely
        if (_this2.consumeQuickAddIntent()) return;
        // Only show when the main product Add to Cart button was clicked shortly before
        if (!_this2.consumeMainButtonIntent()) return;
        var variantId = evt === null || evt === void 0 || (_evt$detail = evt.detail) === null || _evt$detail === void 0 ? void 0 : _evt$detail.variantId;
        try {
          var _evt$detail2, _cart$items, _item$quantity, _item$final_price, _item$final_line_pric, _item$featured_image, _item$featured_image2;
          var cart = evt === null || evt === void 0 || (_evt$detail2 = evt.detail) === null || _evt$detail2 === void 0 ? void 0 : _evt$detail2.cart;
          var item = cart === null || cart === void 0 || (_cart$items = cart.items) === null || _cart$items === void 0 ? void 0 : _cart$items.find(function (i) {
            return (i === null || i === void 0 ? void 0 : i.variant_id) === variantId;
          });
          if (!item) return; // safety
          _this2.showDropdown({
            title: item === null || item === void 0 ? void 0 : item.product_title,
            variantTitle: item === null || item === void 0 ? void 0 : item.variant_title,
            qty: (_item$quantity = item === null || item === void 0 ? void 0 : item.quantity) !== null && _item$quantity !== void 0 ? _item$quantity : 1,
            unitPrice: (_item$final_price = item === null || item === void 0 ? void 0 : item.final_price) !== null && _item$final_price !== void 0 ? _item$final_price : item === null || item === void 0 ? void 0 : item.price,
            linePrice: (_item$final_line_pric = item === null || item === void 0 ? void 0 : item.final_line_price) !== null && _item$final_line_pric !== void 0 ? _item$final_line_pric : undefined,
            cartTotal: cart === null || cart === void 0 ? void 0 : cart.total_price,
            image: (item === null || item === void 0 ? void 0 : item.image) || (item === null || item === void 0 || (_item$featured_image = item.featured_image) === null || _item$featured_image === void 0 ? void 0 : _item$featured_image.url) || (item === null || item === void 0 || (_item$featured_image2 = item.featured_image) === null || _item$featured_image2 === void 0 ? void 0 : _item$featured_image2.src)
          });
        } catch (e) {
          // noop
        }
      });
      document.addEventListener("on:line-item:change", function (evt) {
        var _evt$target$tagName, _evt$target$tagName$t;
        // Ignore Quick Add drawer events
        if (_this2.consumeQuickAddIntent()) return;
        var intentFromMainBtn = _this2.consumeMainButtonIntent();
        var _ref = (evt === null || evt === void 0 ? void 0 : evt.detail) || {},
          _ref$oldQuantity = _ref.oldQuantity,
          oldQuantity = _ref$oldQuantity === void 0 ? 0 : _ref$oldQuantity,
          _ref$newQuantity = _ref.newQuantity,
          newQuantity = _ref$newQuantity === void 0 ? 0 : _ref$newQuantity,
          cart = _ref.cart,
          variantId = _ref.variantId;
        if (typeof oldQuantity !== "number" || typeof newQuantity !== "number") return;
        var fromProductForm = (evt === null || evt === void 0 ? void 0 : evt.target) && ((_evt$target$tagName = evt.target.tagName) === null || _evt$target$tagName === void 0 || (_evt$target$tagName$t = _evt$target$tagName.toLowerCase) === null || _evt$target$tagName$t === void 0 ? void 0 : _evt$target$tagName$t.call(_evt$target$tagName)) === "product-form";
        var fromMainProductForm = fromProductForm && _this2.isFromMainProductForm(evt === null || evt === void 0 ? void 0 : evt.target);
        // Only proceed if change was triggered by the main product form OR we have recent main-button intent
        if (!(intentFromMainBtn || fromMainProductForm)) return;
        var increased = newQuantity > oldQuantity;
        // Some theme paths (e.g. product-form add to existing item) may dispatch equal old/new quantities.
        var addFromFormWithEqualQuantities = fromProductForm && newQuantity === oldQuantity && newQuantity > 0;
        if (increased || addFromFormWithEqualQuantities) {
          try {
            var _cart$items2, _item$final_price2, _item$final_line_pric2, _item$featured_image3, _item$featured_image4;
            var item = cart === null || cart === void 0 || (_cart$items2 = cart.items) === null || _cart$items2 === void 0 ? void 0 : _cart$items2.find(function (i) {
              return (i === null || i === void 0 ? void 0 : i.variant_id) === variantId;
            });
            if (!item) return;
            var qtyAdded = increased ? Math.max(newQuantity - oldQuantity, 1) : 1;
            _this2.showDropdown({
              title: item === null || item === void 0 ? void 0 : item.product_title,
              variantTitle: item === null || item === void 0 ? void 0 : item.variant_title,
              qty: qtyAdded,
              unitPrice: (_item$final_price2 = item === null || item === void 0 ? void 0 : item.final_price) !== null && _item$final_price2 !== void 0 ? _item$final_price2 : item === null || item === void 0 ? void 0 : item.price,
              linePrice: (_item$final_line_pric2 = item === null || item === void 0 ? void 0 : item.final_line_price) !== null && _item$final_line_pric2 !== void 0 ? _item$final_line_pric2 : undefined,
              cartTotal: cart === null || cart === void 0 ? void 0 : cart.total_price,
              image: (item === null || item === void 0 ? void 0 : item.image) || (item === null || item === void 0 || (_item$featured_image3 = item.featured_image) === null || _item$featured_image3 === void 0 ? void 0 : _item$featured_image3.url) || (item === null || item === void 0 || (_item$featured_image4 = item.featured_image) === null || _item$featured_image4 === void 0 ? void 0 : _item$featured_image4.src)
            });
          } catch (e) {
            // noop
          }
        }
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.closeBtn) this.closeBtn.removeEventListener("click", this.hide);
      document.removeEventListener("click", this.handleOutsideClick);
      document.removeEventListener("click", this.handleGlobalClick, true);
      document.removeEventListener("dispatch:cart-drawer:open", this.preventDrawerHandler, true);
    }
  }, {
    key: "money",
    value: function money(cents) {
      if (typeof cents !== "number") return "";
      try {
        var _Shopify, _Shopify2;
        // @ts-ignore
        return (cents / 100).toLocaleString(((_Shopify = Shopify) === null || _Shopify === void 0 ? void 0 : _Shopify.locale) || "da-DK", {
          style: "currency",
          // @ts-ignore
          currency: ((_Shopify2 = Shopify) === null || _Shopify2 === void 0 || (_Shopify2 = _Shopify2.currency) === null || _Shopify2 === void 0 ? void 0 : _Shopify2.active) || "DKK"
        });
      } catch (e) {
        return "".concat((cents / 100).toFixed(2), " kr");
      }
    }
  }, {
    key: "handleGlobalClick",
    value: function handleGlobalClick(evt) {
      var target = evt.target;
      if (!target) return;
      // Ignore any clicks inside the Quick Add drawer
      if (this.isInQuickAddDrawer(target)) {
        this.quickAddIntentTs = Date.now();
        return;
      }
      // Only consider clicks on the main product Add to Cart button which we mark in Liquid
      var trigger = target.closest('form.js-product-form-main [name="add"], form.js-product-form-main button[name="add"]');
      if (trigger && trigger.hasAttribute("data-atc-dropdown-trigger")) {
        this.mainButtonIntentTs = Date.now();
      }
    }
  }, {
    key: "consumeMainButtonIntent",
    value: function consumeMainButtonIntent() {
      if (this.mainButtonIntentTs && Date.now() - this.mainButtonIntentTs < 5000) {
        this.mainButtonIntentTs = null;
        return true;
      }
      return false;
    }
  }, {
    key: "consumeQuickAddIntent",
    value: function consumeQuickAddIntent() {
      if (this.quickAddIntentTs && Date.now() - this.quickAddIntentTs < 5000) {
        this.quickAddIntentTs = null;
        return true;
      }
      return false;
    }
  }, {
    key: "isFromMainProductForm",
    value: function isFromMainProductForm(el) {
      if (!el) return false;
      try {
        // product-form element wraps a form with class .js-product-form-main on the product page
        return !!el.querySelector("form.js-product-form-main");
      } catch (e) {
        return false;
      }
    }
  }, {
    key: "isInQuickAddDrawer",
    value: function isInQuickAddDrawer(el) {
      if (!el) return false;
      try {
        return !!el.closest(".quick-add-drawer");
      } catch (_unused) {
        return false;
      }
    }
  }, {
    key: "showDropdown",
    value: function showDropdown(data) {
      var _data$featured_image,
        _data$featured_image2,
        _data$media$,
        _this3 = this;
      if (this.titleEl && data !== null && data !== void 0 && data.title) this.titleEl.textContent = data.title;
      if (this.variantEl) this.variantEl.textContent = (data === null || data === void 0 ? void 0 : data.variantTitle) || "";
      var qty = Number(data === null || data === void 0 ? void 0 : data.qty) || 1;
      var unitPrice = typeof (data === null || data === void 0 ? void 0 : data.unitPrice) === "number" ? data.unitPrice : typeof (data === null || data === void 0 ? void 0 : data.linePrice) === "number" && qty > 0 ? Math.round(data.linePrice / qty) : undefined;
      if (this.lineEl && typeof unitPrice === "number") {
        this.lineEl.textContent = "".concat(qty, " \xD7 ").concat(this.money(unitPrice));
      }
      if (this.totalEl && typeof (data === null || data === void 0 ? void 0 : data.cartTotal) === "number") {
        this.totalEl.textContent = this.money(data.cartTotal);
      }
      var imgUrl = (data === null || data === void 0 ? void 0 : data.image) || (data === null || data === void 0 ? void 0 : data.featuredImage) || (data === null || data === void 0 ? void 0 : data.featured_image) || (data === null || data === void 0 || (_data$featured_image = data.featured_image) === null || _data$featured_image === void 0 ? void 0 : _data$featured_image.src) || (data === null || data === void 0 || (_data$featured_image2 = data.featured_image) === null || _data$featured_image2 === void 0 ? void 0 : _data$featured_image2.url);
      if (!imgUrl && data !== null && data !== void 0 && data.media && (_data$media$ = data.media[0]) !== null && _data$media$ !== void 0 && (_data$media$ = _data$media$.preview_image) !== null && _data$media$ !== void 0 && _data$media$.src) {
        imgUrl = data.media[0].preview_image.src;
      }
      if (imgUrl && typeof imgUrl === "string" && imgUrl.startsWith("//")) imgUrl = "https:".concat(imgUrl);
      if (this.imageEl && imgUrl) {
        this.imageEl.src = imgUrl;
        this.imageEl.alt = (data === null || data === void 0 ? void 0 : data.title) || "";
      }
      this.hidden = false;
      requestAnimationFrame(function () {
        _this3.classList.remove("tw:-translate-y-full", "tw:opacity-0", "tw:invisible");
      });
      if (this.hideTimer) window.clearTimeout(this.hideTimer);
      this.hideTimer = window.setTimeout(this.hide, 3000);
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this4 = this;
      this.classList.add("tw:-translate-y-full", "tw:opacity-0", "tw:invisible");
      window.setTimeout(function () {
        _this4.hidden = true;
      }, 350);
    }
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick(evt) {
      if (this.hidden) return;
      if (!this.inner) return;
      var target = evt.target;
      if (!this.contains(target)) return;
      if (!this.inner.contains(target)) this.hide();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Bundle/Bundle.ts":
/*!*******************************************************!*\
  !*** ./resources/scripts/components/Bundle/Bundle.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Bundle)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */
/* eslint-disable prefer-template */
/* eslint-disable class-methods-use-this */
/* eslint-disable consistent-return */
/* eslint-disable no-console */
var Bundle = /*#__PURE__*/function (_HTMLElement) {
  function Bundle() {
    var _this;
    _classCallCheck(this, Bundle);
    _this = _callSuper(this, Bundle);
    _defineProperty(_this, "bundleItems", []);
    _defineProperty(_this, "addToCartButton", void 0);
    _defineProperty(_this, "addToCartAnchor", null);
    _defineProperty(_this, "productUrl", _this.dataset.producturl);
    _defineProperty(_this, "loadingOverlay", _this.querySelector(".loading-overlay"));
    _this.initEventListeners = _this.initEventListeners.bind(_this);
    _this.moveOverlaysOutOfMain = _this.moveOverlaysOutOfMain.bind(_this);
    _this.toggleBundleItemDrawer = _this.toggleBundleItemDrawer.bind(_this);
    _this.addBundleDrawerEventListeners = _this.addBundleDrawerEventListeners.bind(_this);
    _this.handleSizeSelectChange = _this.handleSizeSelectChange.bind(_this);
    _this.addToBundle = _this.addToBundle.bind(_this);
    _this.toggleDisableStateAddToCartButton = _this.toggleDisableStateAddToCartButton.bind(_this);
    _this.handleAddBundleToCart = _this.handleAddBundleToCart.bind(_this);
    _this.toggleCartDrawer = _this.toggleCartDrawer.bind(_this);
    return _this;
  }
  _inherits(Bundle, _HTMLElement);
  return _createClass(Bundle, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$closest,
        _this$closest2,
        _this$closest3,
        _this2 = this;
      console.log("Bundle component connected!");
      // Initialize bundle items and add to cart button
      this.bundleItems = Array.from(this.querySelectorAll(".bundle-item"));
      // Find the submit button robustly across theme variations (with or without a <buy-buttons> wrapper)
      this.addToCartButton = ((_this$closest = this.closest(".product")) === null || _this$closest === void 0 ? void 0 : _this$closest.querySelector('.product-info__add-button button[type="submit"]')) || ((_this$closest2 = this.closest(".product")) === null || _this$closest2 === void 0 ? void 0 : _this$closest2.querySelector('button[name="add"]'));
      // If the theme wraps the submit button in an anchor (e.g. <a class="buy-buttons">...)</a>)
      this.addToCartAnchor = (_this$closest3 = this.closest(".product")) === null || _this$closest3 === void 0 ? void 0 : _this$closest3.querySelector("a.buy-buttons");
      console.log("Found bundle items:", this.bundleItems.length);
      console.log("Found add to cart button:", !!this.addToCartButton);
      if (this.addToCartButton) {
        this.toggleDisableStateAddToCartButton(this.addToCartButton);
      }
      this.moveOverlaysOutOfMain();
      // Add a small delay to ensure DOM is ready after moving overlays
      setTimeout(function () {
        _this2.initEventListeners();
      }, 10);
    }
  }, {
    key: "initEventListeners",
    value: function initEventListeners() {
      var _this3 = this;
      console.log("Initializing bundle event listeners for", this.bundleItems.length, "items");
      // Use event delegation for more reliable event handling
      this.addEventListener("click", function (event) {
        var target = event.target;
        var bundleItem = target.closest(".bundle-item");
        if (bundleItem && _this3.bundleItems.includes(bundleItem)) {
          event.preventDefault();
          console.log("Bundle item clicked via delegation:", bundleItem.id);
          _this3.handleBundleItemClicked(bundleItem);
        }
      });
      if (this.addToCartButton) {
        this.addToCartButton.addEventListener("click", /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  event.preventDefault();
                  event.stopPropagation();
                  _context.n = 1;
                  return _this3.handleAddBundleToCart();
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
      // In some themes the button is wrapped in a link which can hijack the click.
      // Also intercept that to ensure we add the bundle instead of submitting the product form/navigating.
      if (this.addToCartAnchor) {
        this.addToCartAnchor.addEventListener("click", /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  event.preventDefault();
                  event.stopPropagation();
                  _context2.n = 1;
                  return _this3.handleAddBundleToCart();
                case 1:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
    }
  }, {
    key: "handleBundleItemClicked",
    value: function handleBundleItemClicked(item) {
      this.toggleBundleItemDrawer(item);
    }
    // Theme specific methods to move overlays ontop of the header
  }, {
    key: "moveOverlaysOutOfMain",
    value: function moveOverlaysOutOfMain() {
      var overlays = Array.from(this.querySelectorAll(".bundle-item-overlay"));
      overlays.forEach(function (overlay) {
        document.body.appendChild(overlay);
      });
    }
  }, {
    key: "toggleBundleItemDrawer",
    value: function toggleBundleItemDrawer(item) {
      var itemId = item.id;
      console.log("Toggling bundle drawer for item:", itemId);
      var overlay = document.querySelector(".bundle-item-overlay[data-target=\"".concat(itemId, "\"]"));
      if (!overlay) {
        console.error("Overlay not found for item:", itemId);
        return;
      }
      var drawer = overlay.querySelector(".bundle-item-drawer");
      console.log("Found overlay and drawer:", overlay, drawer);
      var isCurrentlyOpen = overlay.getAttribute("aria-hidden") === "false";
      console.log("Is currently open:", isCurrentlyOpen);
      if (isCurrentlyOpen) {
        // Animate out
        drawer.style.transform = "translateX(100%)";
        setTimeout(function () {
          overlay.setAttribute("aria-hidden", "true");
          drawer.setAttribute("aria-hidden", "true");
          document.body.style.overflow = "";
        }, 250); // Wait for the transition before hiding
      } else {
        // Open the overlay immediately
        overlay.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
        setTimeout(function () {
          drawer.setAttribute("aria-hidden", "false");
          drawer.style.transform = "translateX(0)";
        }, 1);
      }
      this.addBundleDrawerEventListeners(overlay, item);
    }
  }, {
    key: "addBundleDrawerEventListeners",
    value: function addBundleDrawerEventListeners(overlay, item) {
      var _this4 = this;
      var closeBundleToggle = overlay.querySelector(".overlay-toggle");
      // Only add the event listener once
      if (!closeBundleToggle.hasAttribute("data-event-listener")) {
        closeBundleToggle.addEventListener("click", function (event) {
          event.preventDefault();
          _this4.toggleBundleItemDrawer(item);
        });
        closeBundleToggle.setAttribute("data-event-listener", "true");
      }
      // if clicking on the overlay, close the drawer
      overlay.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (event.target === overlay) {
          _this4.toggleBundleItemDrawer(item);
        }
      });
      var selectSizeElements = Array.from(overlay.querySelectorAll("select"));
      selectSizeElements.forEach(function (select) {
        if (!select.hasAttribute("data-event-listener")) {
          select.addEventListener("change", function () {
            _this4.handleSizeSelectChange(select);
          });
          select.setAttribute("data-event-listener", "true");
        }
        // Initialize button data attributes to match the currently selected option
        _this4.handleSizeSelectChange(select);
      });
      var addToBundleButtons = Array.from(overlay.querySelectorAll(".add-to-bundle"));
      addToBundleButtons.forEach(function (button) {
        if (!button.hasAttribute("data-event-listener")) {
          button.addEventListener("click", function (event) {
            event.preventDefault();
            _this4.addToBundle(button);
          });
          button.setAttribute("data-event-listener", "true");
        }
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "handleSizeSelectChange",
    value: function handleSizeSelectChange(select) {
      var closestBundleItem = select.closest(".bundle-item-info-wrapper");
      var addToBundleButton = closestBundleItem.querySelector(".add-to-bundle");
      addToBundleButton.setAttribute("data-id", select.value);
      addToBundleButton.setAttribute("data-title", select.options[select.selectedIndex].dataset.title);
    }
  }, {
    key: "addToBundle",
    value: function addToBundle(button) {
      var _button$dataset = button.dataset,
        color = _button$dataset.color,
        id = _button$dataset.id,
        image = _button$dataset.image,
        title = _button$dataset.title,
        productTitle = _button$dataset.productTitle;
      // Get the id of the drawer, so we can find the corresponding item
      var closestOverlay = button.closest(".bundle-item-overlay");
      var overlayId = closestOverlay.getAttribute("data-target");
      // Get the item that corresponds to the overlay
      var item = document.querySelector("#".concat(overlayId));
      // mark the bundle as selected
      item.setAttribute("aria-selected", "true");
      var bundleItemInfoWrapper = item.querySelector(".bundle-item-selection");
      // replace the image with the selected image
      var imageElement = bundleItemInfoWrapper.querySelector(".bundle-item-image");
      imageElement.src = image;
      // replace the product title
      var productElement = bundleItemInfoWrapper.querySelector(".bundle-item-product");
      var productWrapper = item.querySelector(".bundle-product-wrapper");
      if (productElement && productWrapper && productTitle) {
        productElement.textContent = productTitle;
        productWrapper.classList.remove("tw:opacity-0");
      }
      // replace the title with the selected title (size)
      var titleElement = bundleItemInfoWrapper.querySelector(".bundle-item-title");
      var titleWrapper = item.querySelector(".bundle-title-wrapper");
      if (title === "Default Title") {
        titleElement.textContent = "";
        titleWrapper.classList.add("tw:opacity-0");
      } else {
        titleElement.textContent = title;
        titleWrapper.classList.remove("tw:opacity-0");
      }
      // replace the id with the selected id
      item.setAttribute("data-id", id);
      // close the drawer
      this.toggleBundleItemDrawer(item);
      this.toggleDisableStateAddToCartButton(this.addToCartButton);
    }
  }, {
    key: "toggleDisableStateAddToCartButton",
    value: function toggleDisableStateAddToCartButton(button) {
      button.disabled = this.bundleItems.every(function (item) {
        return item.getAttribute("aria-selected") !== "true";
      });
    }
    // eslint-disable-next-line consistent-return
  }, {
    key: "handleAddBundleToCart",
    value: function () {
      var _handleAddBundleToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var shop, token, bundleComponents, metaobjectId, productId, body, response, refreshedToken, retryResponse, data, bundle, message, variant, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              this.loadingOverlay.style.display = "flex";
              shop = window.Shopify.shop;
              _context3.n = 1;
              return this.getJwtToken(shop);
            case 1:
              token = _context3.v;
              // Get the JWT token (or refresh if expired)
              bundleComponents = this.bundleItems.map(function (item) {
                return item.getAttribute("data-id");
              });
              metaobjectId = this.getAttribute("data-metaobjectid");
              productId = this.getAttribute("data-productid");
              body = {
                productId: productId,
                bundleComponents: bundleComponents,
                metaobjectId: metaobjectId,
                shop: shop
              };
              _context3.n = 2;
              return fetch("http://bundle-app.edition.dk/api/bundle", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer ".concat(token) // Use the JWT token
                },
                body: JSON.stringify(body)
              });
            case 2:
              response = _context3.v;
              if (response.ok) {
                _context3.n = 8;
                break;
              }
              if (!(response.status === 401)) {
                _context3.n = 7;
                break;
              }
              // Token expired or unauthorized
              console.log("Token expired. Attempting to refresh token...");
              _context3.n = 3;
              return this.getJwtToken(window.Shopify.shop);
            case 3:
              refreshedToken = _context3.v;
              _context3.n = 4;
              return fetch("http://bundle-app.edition.dk/api/bundle", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer ".concat(refreshedToken)
                },
                body: JSON.stringify(body)
              });
            case 4:
              retryResponse = _context3.v;
              if (retryResponse.ok) {
                _context3.n = 5;
                break;
              }
              throw new Error("Failed to add bundle to cart");
            case 5:
              _context3.n = 6;
              return retryResponse.json();
            case 6:
              return _context3.a(2, _context3.v);
            case 7:
              throw new Error("Failed to add bundle to cart");
            case 8:
              _context3.n = 9;
              return response.json();
            case 9:
              data = _context3.v;
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              bundle = data.bundle, message = data.message, variant = data.variant;
              _context3.n = 10;
              return this.addVariantToCart(variant);
            case 10:
              _context3.n = 12;
              break;
            case 11:
              _context3.p = 11;
              _t = _context3.v;
              console.error("Error adding bundle to cart:", _t);
            case 12:
              _context3.p = 12;
              this.loadingOverlay.style.display = "none";
              return _context3.f(12);
            case 13:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 11, 12, 13]]);
      }));
      function handleAddBundleToCart() {
        return _handleAddBundleToCart.apply(this, arguments);
      }
      return handleAddBundleToCart;
    }() // eslint-disable-next-line class-methods-use-this
  }, {
    key: "toggleCartDrawer",
    value: function toggleCartDrawer() {
      // Refresh the cart drawer contents and open it using theme-supported events
      document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
        bubbles: true
      }));
      document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open"));
    }
  }, {
    key: "addVariantToCart",
    value: function () {
      var _addVariantToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(variant) {
        var _this5 = this;
        var response, pollForVariant, interval, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  id: variant,
                  quantity: 1
                })
              });
            case 1:
              response = _context5.v;
              if (response.ok) {
                _context5.n = 2;
                break;
              }
              throw new Error("Failed to add variant to cart");
            case 2:
              // Because the variant we added to cart might be a variant that was just created, it might not just yet be available for the liquid api.
              // therefor we need to poll the product until it is available.
              // once it is we refresh the cart drawer
              pollForVariant = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                  var pollingResponse, _yield$pollingRespons, variants, _t2;
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.p = _context4.n) {
                      case 0:
                        _context4.p = 0;
                        _context4.n = 1;
                        return fetch("".concat(_this5.productUrl, ".json"));
                      case 1:
                        pollingResponse = _context4.v;
                        if (pollingResponse.ok) {
                          _context4.n = 2;
                          break;
                        }
                        throw new Error("Network response was not ok");
                      case 2:
                        _context4.n = 3;
                        return pollingResponse.json();
                      case 3:
                        _yield$pollingRespons = _context4.v;
                        variants = _yield$pollingRespons.product.variants;
                        if (variants.some(function (_variant) {
                          return _variant.id === Number(variant);
                        })) {
                          // eslint-disable-next-line @typescript-eslint/no-use-before-define
                          clearInterval(interval); // Stop polling when the variant is found
                          _this5.toggleCartDrawer();
                          _this5.loadingOverlay.style.display = "none";
                        }
                        _context4.n = 5;
                        break;
                      case 4:
                        _context4.p = 4;
                        _t2 = _context4.v;
                        console.error("Error polling for variant:", _t2);
                      case 5:
                        return _context4.a(2);
                    }
                  }, _callee4, null, [[0, 4]]);
                }));
                return function pollForVariant() {
                  return _ref3.apply(this, arguments);
                };
              }();
              interval = setInterval(pollForVariant, 1500);
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t3 = _context5.v;
              console.error(_t3);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, null, [[0, 3]]);
      }));
      function addVariantToCart(_x3) {
        return _addVariantToCart.apply(this, arguments);
      }
      return addVariantToCart;
    }()
  }, {
    key: "getJwtToken",
    value: function () {
      var _getJwtToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(shop) {
        var token, _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              token = localStorage.getItem("jwtTokenBundle"); // If no token, or the token is expired, request a new one
              if (!(!token || this.isTokenExpired(token))) {
                _context6.n = 2;
                break;
              }
              console.log("Token expired or missing. Getting a new token...");
              _context6.n = 1;
              return this.refreshJwtToken(shop);
            case 1:
              token = _context6.v;
            case 2:
              return _context6.a(2, token);
            case 3:
              _context6.p = 3;
              _t4 = _context6.v;
              console.error("Failed to get JWT token", _t4);
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 3]]);
      }));
      function getJwtToken(_x4) {
        return _getJwtToken.apply(this, arguments);
      }
      return getJwtToken;
    }() // Check if the token is expired
  }, {
    key: "isTokenExpired",
    value: function isTokenExpired(token) {
      var decodedToken = this.decodeJwtToken(token);
      if (decodedToken && decodedToken.exp) {
        var expiry = decodedToken.exp * 1000; // Convert to milliseconds
        return Date.now() > expiry;
      }
      return false;
    }
    // Decode JWT token (you can use any JWT library here)
  }, {
    key: "decodeJwtToken",
    value: function decodeJwtToken(token) {
      try {
        var base64Url = token.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(atob(base64).split("").map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
        return JSON.parse(jsonPayload);
      } catch (e) {
        console.error("Failed to decode JWT token", e);
        return null;
      }
    }
    // Refresh the JWT token
  }, {
    key: "refreshJwtToken",
    value: function () {
      var _refreshJwtToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(shop) {
        var response, data, jwtToken;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return fetch("http://bundle-app.edition.dk/api/auth", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  shop: shop
                }) // Send shop identifier
              });
            case 1:
              response = _context7.v;
              if (response.ok) {
                _context7.n = 2;
                break;
              }
              throw new Error("Failed to refresh token");
            case 2:
              _context7.n = 3;
              return response.json();
            case 3:
              data = _context7.v;
              jwtToken = data.token;
              localStorage.setItem("jwtTokenBundle", jwtToken);
              return _context7.a(2, jwtToken);
          }
        }, _callee7);
      }));
      function refreshJwtToken(_x5) {
        return _refreshJwtToken.apply(this, arguments);
      }
      return refreshJwtToken;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/CustomDropdown/CustomDropdown.ts":
/*!***********************************************************************!*\
  !*** ./resources/scripts/components/CustomDropdown/CustomDropdown.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CustomDropdown)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CustomDropdown = /*#__PURE__*/function (_HTMLElement) {
  function CustomDropdown() {
    var _this;
    _classCallCheck(this, CustomDropdown);
    _this = _callSuper(this, CustomDropdown);
    _defineProperty(_this, "dropdownHeader", null);
    _defineProperty(_this, "dropdownContent", null);
    _defineProperty(_this, "dropdownText", null);
    _defineProperty(_this, "dropdownItems", null);
    _defineProperty(_this, "addToCartButton", null);
    _defineProperty(_this, "optionSelector", null);
    _this.handleHeaderClick = _this.handleHeaderClick.bind(_this);
    _this.handleItemClick = _this.handleItemClick.bind(_this);
    _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
    _this.handleAddToCartClick = _this.handleAddToCartClick.bind(_this);
    return _this;
  }
  _inherits(CustomDropdown, _HTMLElement);
  return _createClass(CustomDropdown, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      // Find all necessary elements
      this.dropdownHeader = this.querySelector("#dropdownHeader");
      this.dropdownContent = this.querySelector("#dropdownContent");
      this.dropdownText = this.querySelector("#dropdownText");
      this.dropdownItems = this.querySelectorAll(".dropdown-item");
      this.optionSelector = this.closest('[data-selector-type="custom-dropdown"]');
      // Find add to cart button in the form
      var form = this.closest("form") || document.querySelector("product-form form");
      this.addToCartButton = (form === null || form === void 0 ? void 0 : form.querySelector(".product-form--atc-button.cstm_btn_fk")) || null;
      // Attach event listeners
      if (this.dropdownHeader) {
        this.dropdownHeader.addEventListener("click", this.handleHeaderClick);
      }
      if (this.dropdownItems) {
        this.dropdownItems.forEach(function (item) {
          item.addEventListener("click", _this2.handleItemClick);
        });
      }
      if (this.addToCartButton) {
        this.addToCartButton.addEventListener("click", this.handleAddToCartClick);
      }
      // Global click listener for closing dropdown
      document.addEventListener("click", this.handleOutsideClick);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this3 = this;
      // Clean up event listeners
      if (this.dropdownHeader) {
        this.dropdownHeader.removeEventListener("click", this.handleHeaderClick);
      }
      if (this.dropdownItems) {
        this.dropdownItems.forEach(function (item) {
          item.removeEventListener("click", _this3.handleItemClick);
        });
      }
      if (this.addToCartButton) {
        this.addToCartButton.removeEventListener("click", this.handleAddToCartClick);
      }
      document.removeEventListener("click", this.handleOutsideClick);
    }
  }, {
    key: "handleHeaderClick",
    value: function handleHeaderClick(event) {
      event.stopPropagation();
      if (!this.dropdownContent) return;
      this.dropdownContent.classList.toggle("show");
      if (this.dropdownContent.classList.contains("show")) {
        this.dropdownContent.style.border = "1px solid #ccc";
      } else {
        this.dropdownContent.style.border = "none";
      }
    }
  }, {
    key: "handleItemClick",
    value: function handleItemClick(event) {
      var target = event.currentTarget;
      var selectedValue = target.getAttribute("data-value");
      if (!selectedValue) return;
      // Update dropdown text
      if (this.dropdownText) {
        this.dropdownText.innerHTML = "St\xF8rrelse: <strong>".concat(selectedValue, "</strong>");
      }
      // Close dropdown
      if (this.dropdownContent) {
        this.dropdownContent.classList.remove("show");
        this.dropdownContent.style.border = "none";
      }
      // Update selected state
      if (this.dropdownItems) {
        this.dropdownItems.forEach(function (item) {
          return item.classList.remove("selected");
        });
      }
      target.classList.add("selected");
      // Update hidden radio inputs and trigger change event
      this.updateVariantSelection(selectedValue);
    }
  }, {
    key: "updateVariantSelection",
    value: function updateVariantSelection(selectedValue) {
      if (!this.optionSelector) return;
      var radios = this.optionSelector.querySelectorAll('input[type="radio"].js-option');
      radios.forEach(function (radio) {
        var shouldCheck = radio.value === selectedValue;
        radio.checked = shouldCheck;
        if (shouldCheck) {
          // Trigger change event on the checked radio
          radio.dispatchEvent(new Event("change", {
            bubbles: true
          }));
        }
      });
      // Also dispatch change event on the option-selector itself
      this.optionSelector.dispatchEvent(new Event("change", {
        bubbles: true
      }));
    }
  }, {
    key: "handleAddToCartClick",
    value: function handleAddToCartClick(event) {
      if (!this.dropdownText) return;
      var currentText = this.dropdownText.innerText.trim();
      if (currentText === "Vælg Størrelse") {
        event.preventDefault();
        event.stopPropagation();
        var button = event.currentTarget;
        var originalText = button.innerText;
        var originalBGColor = button.style.backgroundColor;
        button.innerText = "Vælg venligst en størrelse";
        button.style.backgroundColor = "#a6a6a6";
        setTimeout(function () {
          button.innerText = originalText;
          button.style.backgroundColor = originalBGColor;
        }, 1500);
      }
    }
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick(event) {
      var target = event.target;
      if (!this.contains(target) && this.dropdownContent) {
        this.dropdownContent.classList.remove("show");
        this.dropdownContent.style.border = "none";
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/ShowMoreVariants/ShowMoreVariants.ts":
/*!***************************************************************************!*\
  !*** ./resources/scripts/components/ShowMoreVariants/ShowMoreVariants.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ShowMoreVariants)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var ShowMoreVariants = /*#__PURE__*/function (_HTMLElement) {
  function ShowMoreVariants() {
    var _this;
    _classCallCheck(this, ShowMoreVariants);
    _this = _callSuper(this, ShowMoreVariants);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  _inherits(ShowMoreVariants, _HTMLElement);
  return _createClass(ShowMoreVariants, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.addEventListener("click", this.handleClick);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var variantsContainer = this.closest(".ProductMeta__Variants");
      if (!variantsContainer) {
        this.remove();
        return;
      }
      var variantItems = variantsContainer.querySelectorAll("a.colors__item");
      variantItems.forEach(function (item) {
        if (item.classList.contains("tw:hidden")) {
          item.classList.remove("tw:hidden");
        }
      });
      this.remove();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/edition": 0,
/******/ 			"shopify-theme/assets/edition": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkmodekompagniet_dk"] = self["webpackChunkmodekompagniet_dk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;